/**
 * @module messenger/model/message
 * @todo TODO Message should implement MessageData
 */
export type MessageData = {
  sender: string;
  recipient: string;
  body: string;
  time: number;
  isMine: boolean;
  payload: MessagePayload;
  attachment: AttachmentData | null;
  fromLivecam?: true;
};

/**
 * uhura style the acng backend has no status property but a "locked" flag
 * @example
 * {
 *   "id": 8658605,
 *   "status": "ok",
 *   "name": "20231101_172158.jpg",
 *   "url": "/171/423/017/u17142317/files/file17142317.1698861859.jpg"
 * }
 */
export type AttachmentData = {
  id: number;
  status: 'ok' | 'locked' | 'deleted';
  name: string;
  url: string;
};

export type MessagePayload = {
  type?: 'match' | 'kiss' | 'game.invitation' | 'sexicon' | 'regard' | 'payttachment' | 'voice';
  text?: string;
  image?: string;
  ibid?: number;
  ibts?: string;
  ibb?: unknown;
  payttachment?: import('../factory/payttachment').PayttachmentData;
  utm_id?: unknown;
  id?: unknown;
};

import {Amateur} from 'acng/amateurPool/factory/Amateur';
import {media, UTM} from 'acng/core/service/env';
import {inject} from 'acng/core/service/ng';
import kissImageSrc from 'assets/basic/img/kiss.small.png';

export class Message {
  amateur: Amateur;
  sender: string;
  recipient: string;
  originalBody: string;
  body: string;
  time: Date;
  isMine: boolean;
  payload: MessagePayload;
  attachment: AttachmentData | null;
  ready: boolean;
  icon?: string;
  constructor(amateur: Amateur, data: MessageData) {
    this.amateur = amateur;
    this.sender = data.sender;
    this.recipient = data.recipient;
    this.time = new Date(data.time);
    this.originalBody = data.body;
    // Filter and escape unclosed < chars, because the angular sanitzier cuts the string at the position.
    this.body = data.body.replace(/<(?![^<]+>)/g, '&lt;');
    this.isMine = data.isMine;
    this.payload = data.payload;
    this.attachment = data.attachment;
    this.ready = false;
    this.icon = undefined;

    const {type, image} = this.payload;
    const $translate = inject('$translate');
    switch (type) {
      case 'kiss':
        this.payload.image = `${media.assets}/${kissImageSrc}`;
        this.payload.text = $translate.instant('kiss.received');
        break;
      case 'match':
        this.icon = 'match2';
        this.payload.text = $translate.instant('hotornot.systemMessageMatch');
        break;
      case 'game.invitation':
        this.icon = 'gameColor';
        this.payload.text = $translate.instant('games.invited');
        break;
      case 'sexicon':
      case 'regard':
        if (!image) {
          console.warn('messenger/factory/message sexicon or regard without image');
          break;
        }
        if (!/^http/.test(image)) {
          this.payload.image = `${media.content.items}${image}`;
        }
        break;
    }

    if (this.attachment && this.attachment.status !== 'deleted') {
      // prefix the attachment url with cdn host if needed.
      // TODO why pictures? it could be a movie too
      // TODO the acng backend should send the same format as uhura/troi does
      if (!/^http/.test(this.attachment.url)) {
        this.attachment.url = `${media.content.pictures}${this.attachment.url}`;
      }
    }
  }

  isFresh() {
    return Date.now() - this.time.getTime() < 15e3;
  }

  async getMessageText() {
    if (this.payload.utm_id) {
      return this.translate().then((message) => message.body);
    }

    const $translate = inject('$translate');
    switch (this.payload.type) {
      case 'payttachment':
        return $translate.instant('messenger.payttachment.message');
      case 'sexicon':
        return this.isMine ? $translate.instant('sexicon.sent') : this.body;
      case 'kiss':
        return $translate.instant('kiss.kissed');
      case 'game.invitation':
        return $translate.instant('games.invited');
      case 'match':
        return $translate.instant('hotornot.systemMessageMatch');
      case 'voice':
        return $translate.instant('messenger.voicemessage.preview');
      default:
        return this.body;
    }
  }

  getAmateurId() {
    return this.isMine ? this.recipient : this.sender;
  }

  isIcebreaker() {
    return (this.payload.ibid ?? 0) > 0;
  }

  async translate() {
    if (!this.body && this.payload.utm_id) {
      const http = inject('http');
      try {
        const res = await http().get(`${UTM}/translation/${this.payload.utm_id}`);
        this.body = this.isMine
          ? res.data.source_text //
          : res.data.translated_text;
      } catch (reason) {
        console.error(`Message.translate UTM#${this.payload.utm_id} error`, {message: this, reason});
      }
    }
    this.ready = true;
    return this;
  }
}
